import { store } from 'store/store';
import { paper as PaperJS } from 'paper';
import fontlib from 'bwip-js/browser-fonts';
import bwipjs from 'bwip-js/bwipjs';
import bwipp from 'bwip-js/bwipp';

import {
    isHandleCorner,
    isImage,
    isBarcode,
    isSquareBarcode,
    isRFID,
    isAutoScaleTypeLayer,
    getLayerExtendedData,
    getCanvasItem,
    getCurve,
    getTagData,
    generatePreviewSequence,
    getBiggestLayerArea,
    getPreset,
    togglehandleCorners,
    getShadowboundCanvasItem,
    getTextCanvasItem,
    getGlyphsFromString,
} from '../selectors/defaultSelectors';
import {
    toggleLayerError,
    selectLayer as selectEditorLayer,
    changeLayerPosition,
    changeLayerScale,
    focusContentField,
    changeLayerRotation,
    changeLayerTextOrientation,
    changeLayerField,
    changeLayerMaxWidth,
} from '../actions/editorActions';
import { changeScreen } from '../actions/tagWizardActions';

const handleSize = 9;
const handleSizeRegion = handleSize;
// const handleSize = window.innerWidth <= 767 ? 55 : 9;
// const handleSizeRegion = window.innerWidth <= 767 ? handleSize * 1.5 : handleSize;
const handleColor = '#67FEFE';
// const handleColor = 'rgba(0,0,0,0)';
const selectionColor = '#67FEFE';
// const selectionColor = '#FF003A';
const selectionWidth = 1;
const minScaleX = 0.05;
const minScaleY = 0.05;
export const CANVAS_WIDTH = 800;
const BARCODE_DEFAULT_WIDTH = 200;
const BARCODE_DEFAULT_HEIGHT = 200;
const INITIAL_IMAGE_MAX_WIDTH = 350;
const INITIAL_IMAGE_MAX_HEIGHT = 350;

/**
 * Helper function to recalculate CANVAS_WIDTH
 * @returns {number}
 */
export const getCanvasWidth = () => CANVAS_WIDTH * window.devicePixelRatio;

function PaperJSVector(scope, rot, bgcolor) {
    this.pad = function(x, y) {};
    this.color = function(r, g, b) {};

    this.imageinfo = function(width, height) {
        scope.project.view.viewSize = [width, height];
    };

    this.set = function(x, y, width, height) {
        const point = new PaperJS.Point(x, y);
        const size = new PaperJS.Size(width, height);
        const rect = new PaperJS.Path.Rectangle(point, size);
        rect.addTo(scope.project);
    };

    this.finalize = function(callback) {
        callback(null, scope);
    };
}
function customBWIPJS(opts, callback) {
    const scale = opts.scale || 2;
    const scaleX = +opts.scaleX || scale;
    const scaleY = +opts.scaleY || scaleX;

    // setup PaperJS
    const scope = new PaperJS.PaperScope();
    scope.setup([50, 50]);

    // setup bwip
    const bw = new bwipjs(fontlib, false);
    bw.imagemask = function(width, height, source) {
        var tx = Math.floor(this.g_tdx);
        var ty = Math.floor(this.g_tdy);
        var dx = Math.floor(this.g_tsx / width); // pixel width
        var dy = Math.floor(this.g_tsy / height); // pixel height
        var rl = Math.ceil(width / 8); // row length (bytes per row)
        var y0 = ty + height * dy;
        var x0;

        this.bbox(tx, ty, dx * width, dy * height);
        for (var y = 0; y < height; y++) {
            x0 = tx;
            y0 -= dy;
            for (var x = 0; x < width; x++) {
                var by = source[y * rl + (x >>> 3)];
                var bt = by & (1 << (7 - (x & 7)));
                if (bt) {
                    this.bmap.set(x0, y0, dx, dy);
                }
                x0 += dx;
            }
        }

        groupPaths(scope);
    };
    bw.drawline = function(optmz, x1, y1, x2, y2, penx, peny, merge) {
        if (optmz && (x1 == x2 || y1 == y2)) {
            var lx = Math.round(penx);
            var ly = Math.round(peny);
            var t;

            if (y2 < y1) {
                t = y1;
                y1 = y2;
                y2 = t;
            }
            if (x2 < x1) {
                t = x1;
                x1 = x2;
                x2 = t;
            }

            // Horizontal or vertical line?
            if (x1 == x2) {
                // Vertical line
                x1 = Math.floor(x1 - lx / 2);
                x2 = Math.floor(x2 + lx / 2);
                y1 = Math.floor(y1 - (merge ? ly / 2 : 0));
                y2 = Math.floor(y2 + (merge ? ly / 2 : 0));
            } else {
                // Horizontal line
                y1 = Math.floor(y1 - ly / 2);
                y2 = Math.floor(y2 + ly / 2);
                x1 = Math.floor(x1 - (merge ? lx / 2 : 0));
                x2 = Math.floor(x2 + (merge ? lx / 2 : 0));
            }
            this.bmap.set(x1, y1, penx, y2);
            groupPaths(scope);
        }
    };
    bw.bitmap(new PaperJSVector(scope, 'N'));
    bw.scale(scaleX, scaleY);
    try {
        bwipp()(bw, opts.bcid, opts.text, opts);
        bw.render(callback);
    } catch (e) {
        callback(e.message, scope);
    }
}

// setup
export const resetCanvases = () => {
    return (dispatch, getState) => {
        const { editor } = getState();
        const { canvas } = editor.present;

        Object.values(canvas).map((scope) => {
            scope.remove();
        });

        dispatch({
            type: 'RESET_CANVAS',
        });
    };
};

export const setupCanvases = () => {
    return (dispatch, getState) => {
        const { editor, tagWizard } = getState();

        const data = getTagData(editor.present, tagWizard.present);
        const { tagData } = data;

        console.log('data===============', data);

        const { tagType = '' } = tagWizard.present.userInput;

        Object.values(tagData.sides).map((side) => {
            const canvasEl = document.getElementById(`${side.id}-tag`);
            const scope = startPaperJS(canvasEl);

            // Force resize the scope
            if (canvasEl) {
                const canvasElExtras = canvasEl.getBoundingClientRect();
                const currentCanvasWidth =
                    canvasElExtras.width * window.devicePixelRatio;

                console.log(
                    '> Initial force resize',
                    { currentCanvasWidth, canvasWidth: getCanvasWidth() },
                    window.devicePixelRatio,
                    scope.view.size
                );

                scope.view.onResize({
                    size: {
                        width: currentCanvasWidth,
                    },
                    delta: {
                        width: currentCanvasWidth - getCanvasWidth(),
                    },
                });
            }

            const canvasSide = new PaperJS.Group();
            canvasSide.data.id = side.id;
            canvasSide.addTo(scope.project);

            dispatch({
                type: 'SET_CANVAS',
                side: side.id,
                value: scope,
            });

            createCanvasStructure(side, scope, editor.present, 'editor');
            createCanvasClippingMask(side, canvasSide);
            tagType !== '' && createCanvasSelection(side, canvasSide);
            // tagType !== '' &&
            //     tagType !== 'nlis' &&
            //     createCanvasSelection(side, canvasSide);
        });
    };
};

export const hideCanvasSelection = (layer) => {
    const selectionLayer = getCanvasItem('selection', layer.project);
    if (selectionLayer) {
        selectionLayer.position.x = -selectionLayer.bounds.width;
    }
};

export const updateCanvasSelection = (layer) => {
    const selectionLayer = getCanvasItem('selection', layer.project);
    if (!selectionLayer) return;
    const { editor } = store.getState();
    const { layers } = editor.present;
    const editorLayer = layers[layer.data.id];
    const preset = getPreset(editorLayer);
    const autoScaleTypeLayer = isAutoScaleTypeLayer(editorLayer);
    const { curve, nlisOnly } = editorLayer || false;
    const noFreeTransform =
        isSquareBarcode(editorLayer) ||
        isImage(editorLayer) ||
        isRFID(editorLayer); // barcode and images shouldn't be free transformed, only resized
    const noResize = (curve && !noFreeTransform) || isRFID(editorLayer);
    const noTransformation =
        preset.noTransformation || false || nlisOnly || isRFID(editorLayer);
    const rect =
        selectionLayer.getItem({
            recursive: false,
            match: (item) => item.name === 'rect',
        }) || false;
    const handles =
        selectionLayer.getItems({
            recursive: false,
            match: (item) => item !== rect,
        }) || false;

    // reposition and resize the canvas selection
    if (layer.bounds.width === 0 || layer.bounds.height === 0) {
        hideCanvasSelection(selectionLayer);
    } else {
        // For some reason, there is this 'selection' layer inside the layer which messes up the calculation
        // We have to remove it to ensure that the rect consumes correct layer sizing
        const layerSelection =
            layer.getItem({
                match: (item) => item.name === 'selection',
            }) || false;

        if (layerSelection) {
            layerSelection.remove();
        }

        rect.bounds.width = layer.bounds.width;
        rect.bounds.height = layer.bounds.height;
        rect.position = layer.position;
    }

    // reposition and hides specific handles
    handles.forEach((handle) => {
        const isCorner = isHandleCorner(handle.name);
        handle.position = rect.bounds[handle.name];
        if (
            noTransformation ||
            (noFreeTransform && !isCorner) || (noResize && !isCorner)
        ) {
            handle.visible = false;
        } else {
            handle.visible = true;
        }
    });
};
export const selectionLeave = (e) => {
    e.event.target.style.cursor = 'default';
};
export const selectionMove = (e) => {
    const layer = e.target;
    const resizeHit = layer.hitTest(e.point, {
        fill: true,
        segments: true,
        match: ({ item }) => item.data && item.data.type === 'handle',
    });
    const canvas = e.event.target;
    const { activeLayer } = store.getState().editor.present;

    if (!activeLayer) {
        canvas.style.cursor = 'pointer';
        return;
    }

    if (canvas.style.cursor === 'progress') {
        return;
    }

    canvas.style.cursor = 'move';

    if (resizeHit) {
        if (resizeHit.item.name === 'topLeft') {
            canvas.style.cursor = 'nw-resize';
        } else if (resizeHit.item.name === 'topRight') {
            canvas.style.cursor = 'ne-resize';
        } else if (resizeHit.item.name === 'bottomRight') {
            canvas.style.cursor = 'se-resize';
        } else if (resizeHit.item.name === 'bottomLeft') {
            canvas.style.cursor = 'sw-resize';
        } else if (resizeHit.item.name === 'topCenter') {
            canvas.style.cursor = 'n-resize';
        } else if (resizeHit.item.name === 'bottomCenter') {
            canvas.style.cursor = 's-resize';
        } else if (resizeHit.item.name === 'leftCenter') {
            canvas.style.cursor = 'w-resize';
        } else if (resizeHit.item.name === 'rightCenter') {
            canvas.style.cursor = 'e-resize';
        }
    }
};

export const selectionDrag = (e) => {
    e.event.target.style.cursor = 'progress';
    const { editor, tagWizard } = store.getState();
    const { cartQty } = tagWizard.present.userInput;
    const { layers, regions, activeLayer } = editor.present;
    const canvasLayer = getCanvasItem(activeLayer, e.target.project);
    const selectionLayer = getCanvasItem('selection', canvasLayer.project);
    const { movementType } = e.target.data;
    const { id, region, pivot } = canvasLayer.data;
    const editorLayer = getLayerExtendedData(layers[id], cartQty);
    const editorRegion = regions[region];
    const areaBoundBox = getLayerAreaBoundBox(e.target.project, editorRegion);
    const { activeType } = editorLayer;
    const preset = getPreset(editorLayer);
    const { noTransformation, noMovement } = preset;

    if (
        activeType == 'rfid' ||
        (movementType === 'move' && noMovement) ||
        (movementType === 'resize' && noTransformation)
    ) {
        return;
    }

    if (movementType === 'resize') {
        dragScaleLayer(canvasLayer, selectionLayer, editorLayer, e);
        resizeLayer(canvasLayer, editorLayer, areaBoundBox);
    } else if (movementType === 'move') {
        dragMoveLayer(canvasLayer, e);
    }

    // curved layer
    if (pivot) {
        let newPosition = canvasLayer.bounds.center.add(pivot);
        const percentageBounds = {
            x: Number(
                (
                    ((newPosition.x - areaBoundBox.x) * 100) /
                    areaBoundBox.width
                ).toFixed(2)
            ), // correct bound
            y: Number(
                (
                    ((newPosition.y - areaBoundBox.y) * 100) /
                    areaBoundBox.height
                ).toFixed(2)
            ), // correct bound
            width: (canvasLayer.bounds.width * 100) / areaBoundBox.width,
            height: (canvasLayer.bounds.height * 100) / areaBoundBox.height,
        };

        if (movementType === 'resize') {
            // // NOTE: when applyMatrix = true
            // const scale = {
            //     x: Number( (bounds.width / originalSize.width).toFixed(2) ),
            //     y: Number( (bounds.height / originalSize.height).toFixed(2) ),
            // };
            // console.log('original', originalSize);
            // console.log('bounds', bounds);
            // console.log('scale', scale);

            // NOTE: when applyMatrix = false
            const fontSize = layers[activeLayer].fontSize;
            const scaleX = Number(canvasLayer.matrix.scaling.x.toFixed(2));

            store.dispatch(
                changeLayerField({
                    layer: id,
                    target: 'fontSize',
                    value: parseInt(fontSize * scaleX).toString(),
                })
            );

            // Archived
            // const scale = {
            //     x: Number(canvasLayer.matrix.scaling.x.toFixed(2)),
            //     y: Number(canvasLayer.matrix.scaling.y.toFixed(2)),
            // };
            // store.dispatch(changeLayerScale(id, scale));
            // store.dispatch(
            //     changeLayerPosition(id, {
            //         x: percentageBounds.x,
            //         y: percentageBounds.y,
            //     })
            // );
        } else if (movementType === 'move') {
            store.dispatch(
                changeLayerPosition(id, {
                    x: percentageBounds.x,
                    y: percentageBounds.y,
                })
            );
        }

        store.dispatch(changeCanvasLayerField({ layer: id }));
    } else {
        repositionLayer(canvasLayer, areaBoundBox);
        updateCanvasSelection(canvasLayer);
    }
};

export const selectionDown = (e) => {
    e.event.target.style.cursor = 'progress';
    const selection = e.target;
    const resizeHit = selection.hitTest(e.point, {
        fill: true,
        segments: true,
        match: ({ item }) => item.data && item.data.type === 'handle',
    });

    // reset movement type
    selection.data.movementType = 'move';

    // selection hit
    if (resizeHit) {
        selection.data.movementType = 'resize';
        selection.data.segmentPoint = resizeHit.item.name;
    }
};

export const selectionUp = (e) => {
    // mouse up the selection
    const { editor } = store.getState();
    const { regions, activeLayer, layers } = editor.present;
    const canvasLayer = getCanvasItem(activeLayer, e.target.project);
    const { bounds, data } = canvasLayer;
    const { movementType } = e.target.data;
    const { id, region, pivot } = data;
    const editorRegion = regions[region];
    const areaBoundBox = getLayerAreaBoundBox(e.target.project, editorRegion);
    const rectWidth = bounds.width;
    const rectHeight = bounds.height;
    const editorLayer = layers[activeLayer];
    let newPosition = pivot ? bounds.center.add(pivot) : bounds.center;
    const percentageBounds = {
        x: Number(
            (
                ((newPosition.x - areaBoundBox.x) * 100) /
                areaBoundBox.width
            ).toFixed(2)
        ), // correct bound
        y: Number(
            (
                ((newPosition.y - areaBoundBox.y) * 100) /
                areaBoundBox.height
            ).toFixed(2)
        ), // correct bound
        width: (rectWidth * 100) / areaBoundBox.width,
        height: (rectHeight * 100) / areaBoundBox.height,
    };

    if (movementType === 'resize') {
        const autoScaleTypeLayer = isAutoScaleTypeLayer(editorLayer);
        const fontSize = editorLayer.fontSize;

        // for autoScaleTypeLayer
        const shadowBoundItem = getShadowboundCanvasItem(canvasLayer);
        const textItem = getTextCanvasItem(canvasLayer);

        if (pivot) {
            const scaleX = Number(canvasLayer.matrix.scaling.x.toFixed(2));

            store.dispatch(
                changeLayerField({
                    layer: id,
                    target: 'fontSize',
                    value: parseInt(fontSize * scaleX).toString(),
                })
            );
        } else if (autoScaleTypeLayer && shadowBoundItem && textItem) {
            console.log('selectionUp - canvasLayer', canvasLayer);

            // Helper to get the new layer max width
            const newShadowBoundWidth = shadowBoundItem.size.width;

            // Adjust max width
            const newLayerMaxWidth =
                newShadowBoundWidth * canvasLayer.scaling.x;
            store.dispatch(changeLayerMaxWidth(id, newLayerMaxWidth));

            // Adjust scale
            const scale = {
                // x: Number(canvasLayer.matrix.scaling.x.toFixed(2)),
                x: 1 / canvasLayer.scaling.x,
                y: Number(canvasLayer.scaling.y.toFixed(2)),
                // y: Number(canvasLayer.matrix.scaling.y.toFixed(2)),
            };
            store.dispatch(changeLayerScale(id, scale));

            // Adjust position
            store.dispatch(
                changeLayerPosition(id, {
                    x: percentageBounds.x,
                    y: percentageBounds.y,
                })
            );
        } else {
            const scale = {
                x: Number(canvasLayer.matrix.scaling.x.toFixed(2)),
                y: Number(canvasLayer.matrix.scaling.y.toFixed(2)),
            };
            store.dispatch(changeLayerScale(id, scale));
            store.dispatch(
                changeLayerPosition(id, {
                    x: percentageBounds.x,
                    y: percentageBounds.y,
                })
            );
        }
        // Archived
        // const scale = {
        //     x: Number(canvasLayer.matrix.scaling.x.toFixed(2)),
        //     y: Number(canvasLayer.matrix.scaling.y.toFixed(2)),
        // };
        // store.dispatch(changeLayerScale(id, scale));
        // store.dispatch(
        //     changeLayerPosition(id, {
        //         x: percentageBounds.x,
        //         y: percentageBounds.y,
        //     })
        // );
    } else if (movementType === 'move') {
        store.dispatch(
            changeLayerPosition(id, {
                x: percentageBounds.x,
                y: percentageBounds.y,
            })
        );
    }

    e.event.target.style.cursor = 'default';
};

export const createSelectionBinds = (layer) => {
    layer.onMouseLeave = (e) => selectionLeave(e);
    layer.onMouseMove = (e) => selectionMove(e);
    layer.onMouseDrag = (e) => selectionDrag(e);
    //layer.onMouseDrag = _throttle((e) => selectionDrag(e), 20);
    layer.onMouseDown = (e) => selectionDown(e);
    layer.onMouseUp = (e) => selectionUp(e);
};

// render
export const groupPaths = (scope) => {
    const items = scope.project.getItems({ class: 'Path' });
    const group = new PaperJS.CompoundPath();

    group.addTo(scope.project);
    group.addChildren(items);
};
export const flattenSVG = (group, options = {}) => {
    const { type = 'exclude', target = 'Path' } = options;
    const items = group.getItems({
        recursive: true,
        class: target,
        match: (item) => item.data.type !== 'selection',
    });
    let newItem = false;

    items.map((original, i) => {
        original.closed = true;
        if (!newItem) {
            newItem = original.clone({ insert: false });
        } else {
            if (type === 'unite') {
                newItem = newItem.unite(original, { insert: false });
            } else {
                newItem = newItem.exclude(original, { insert: false });
            }
        }
    });

    return newItem;
};
export const getLayerAreaBoundBox = (project, region) => {
    console.log('project.view.bounds===============', project.view.bounds);
    console.log('region.boundaries===============', region.boundaries);
    const regionBoundBox = createBoundBox(
        project.view.bounds,
        region.boundaries
    );
    return regionBoundBox;
};

export const generateBarcode = (barcode, text, project, editorLayer) => {
    const lines = text.split('\n'); 
    const barcodeList = [];
    let firstBarcodeLayer = null;

    lines.forEach((line, index) => {
        const trimmedLine = line.trim();
        if (trimmedLine === '') {
            return;
        }

        customBWIPJS(
            {
                bcid: barcode,
                text: trimmedLine,
                width: 5,
                height: 5,
            },
            (error, scope) => {
                if (error) {
                    store.dispatch(
                        toggleLayerError({
                            layer: editorLayer.id,
                            target: 'barcode',
                            value: true,
                        })
                    );
                } else {
                    const svg = scope.project.exportSVG({ asString: true });
                    const barcodeLayer = project.importSVG(svg, {
                        insert: false,
                    });

                    barcodeLayer.bounds.width = BARCODE_DEFAULT_WIDTH;
                    barcodeLayer.bounds.height = BARCODE_DEFAULT_HEIGHT;

                    barcodeList.push({
                        text: trimmedLine,
                        svg,
                    });

                    if (!firstBarcodeLayer) {
                        firstBarcodeLayer = barcodeLayer;
                    }

                    if (editorLayer.errors.barcode) {
                        store.dispatch(
                            toggleLayerError({
                                layer: editorLayer.id,
                                target: 'barcode',
                                value: false,
                            })
                        );
                    }
                }
            }
        );
    });

    store.dispatch({
        type: 'SAVE_BARCODE_LIST',
        payload: barcodeList,
    });

    console.log('Barcode List:', barcodeList);
    console.log('First Barcode Layer:', firstBarcodeLayer);

    return firstBarcodeLayer;
};

export const getCurveDetails = (areaBoundBox, position) => {
    const positionPoint = getPointByPercentage(areaBoundBox, position);
    const radius = positionPoint.getDistance(areaBoundBox.center);
    const tempPoint1 = new PaperJS.Point(
        positionPoint.x - areaBoundBox.center.x,
        areaBoundBox.center.y - positionPoint.y
    );
    const tempPoint2 = new PaperJS.Point(0, radius);
    const rotationAngle = tempPoint1.getDirectedAngle(tempPoint2);

    const curve = {
        sameAsOrigin:
            areaBoundBox.center.x === positionPoint.x &&
            areaBoundBox.center.y === positionPoint.y,
        origin: areaBoundBox.center,
        radius: radius,
        rotationAngle: rotationAngle,
        // top: positionPoint.y < areaBoundBox.center.y,
        // left: positionPoint.x < areaBoundBox.center.x
    };
    return curve;
};
export const getTextLayer = (project, areaBoundBox, editorLayer, options) => {
    console.log('editorLayer====================', editorLayer);
    const { editor } = store.getState();
    const { fonts, activeLayer } = editor.present;
    const {
        textOrientation,
        position,
        curve = false,
        id,
        types,
        activeType,
        font: fontID,
        fontSize,
        fontSpacing,
        barcode,
        layerMaxWidth = null,
    } = editorLayer;

    const { fields } = types[activeType];
    const { content: text } = fields;

    const font = fonts[fontID].curves;
    let newItem = false;

    if (barcode) {
        newItem = generateBarcode(barcode, text, project, editorLayer);
    }
    console.log('areaBoundBox========================', areaBoundBox);
    console.log('position========================', position);
    if (curve) {
        const curveDetails = getCurveDetails(areaBoundBox, position);

        if (!curveDetails.sameAsOrigin) {
            newItem = createCircleTextLayer(
                curveDetails,
                text,
                font,
                fontSize,
                fontSpacing,
                textOrientation
            );
        }
    } else {
        newItem = createTextLayer(
            text,
            font,
            fontSize,
            fontSpacing,
            layerMaxWidth
        );
    }

    // if (editorLayer.errors.barcode) {
        store.dispatch(
            toggleLayerError({ layer: id, target: 'barcode', value: false })
        );
    // }

    return newItem;
};

export const getSequenceLayer = (
    project,
    areaBoundBox,
    editorLayer,
    options
) => {
    const { editor } = store.getState();
    const { fonts } = editor.present;
    const {
        textOrientation,
        position,
        curve,
        id,
        types,
        activeType,
        font: fontID,
        fontSize,
        fontSpacing,
        barcode,
    } = editorLayer;
    const { fields } = types[activeType];
    const { start, count, step, leadingZeros, prefix, suffix } = fields;
    const { sequenceCount } = options;
    const font = fonts[fontID].curves;
    const previewSequence = generatePreviewSequence(
        start,
        count,
        step,
        leadingZeros,
        prefix,
        suffix
    );
    let displayText =
        typeof sequenceCount !== 'undefined'
            ? previewSequence[sequenceCount]
            : previewSequence[previewSequence.length - 1];
    let text = displayText;
    let newItem = false;

    if (barcode) {
        newItem = generateBarcode(barcode, text, project, editorLayer);
    }

    if (curve) {
        const curveDetails = getCurveDetails(areaBoundBox, position);
        if (!curveDetails.sameAsOrigin) {
            newItem = createCircleTextLayer(
                curveDetails,
                text,
                font,
                fontSize,
                fontSpacing,
                textOrientation
            );
        }
    } else {
        newItem = createTextLayer(text, font, fontSize, fontSpacing);
    }

    // if (editorLayer.errors.barcode) {
        store.dispatch(
            toggleLayerError({ layer: id, target: 'barcode', value: false })
        );
    // }

    return newItem;
};

export const getCustomListLayer = (
    project,
    areaBoundBox,
    editorLayer,
    options
) => {
    const { editor } = store.getState();
    const { fonts } = editor.present;
    const {
        textOrientation,
        position,
        curve,
        id,
        types,
        activeType,
        font: fontID,
        fontSize,
        fontSpacing,
        barcode,
    } = editorLayer;
    const { fields } = types[activeType];
    const { content } = fields;
    const { sequenceCount } = options;
    const font = fonts[fontID].curves;
    // const biggestArea = getBiggestLayerArea(content.split('\n'), font);
    // const displayText =
    //     typeof sequenceCount !== 'undefined'
    //         ? content.split('\n')[sequenceCount]
    //         : biggestArea.text;
    // const lines = content.split('\n').map((line) => line.trim());
    // const displayText =
    //     typeof sequenceCount !== 'undefined' && sequenceCount < lines.length
    //         ? lines[sequenceCount]
    //         : lines[lines.length - 1]; // Default to the last line

      const lines = content.split('\n').map((line) => line.trim());
    const displayText = lines[0];

    const text = displayText;
    let newItem;

    if (barcode) {
        newItem = generateBarcode(barcode, text, project, editorLayer);
    }

    if (curve) {
        const curveDetails = getCurveDetails(areaBoundBox, position);
        if (!curveDetails.sameAsOrigin) {
            newItem = createCircleTextLayer(
                curveDetails,
                text,
                font,
                fontSize,
                fontSpacing,
                textOrientation
            );
        }
    } else {
        newItem = createTextLayer(text, font, fontSize, fontSpacing);
    }

    // if (editorLayer.errors.barcode) {
        store.dispatch(
            toggleLayerError({ layer: id, target: 'barcode', value: false })
        );
    // }

    return newItem;
};

export const getImageLayer = (project, editorLayer) => {
    const { types, activeType, id } = editorLayer;
    const { fields } = types[activeType];
    const { image } = fields;
    const newItem = image ? createSVGLayer(project, image) : false;

    // if (editorLayer.errors.barcode) {
        store.dispatch(
            toggleLayerError({ layer: id, target: 'barcode', value: false })
        );
    // }

    return newItem;
};

export const getCodeLayer = (project, areaBoundBox, editorLayer, options) => {
    const { types, activeType, barcode } = editorLayer;
    const { fields } = types[activeType];
    const {
        content,
        useSequence,
        leadingZeros,
        start,
        prefix,
        suffix,
        count,
        step,
    } = fields;

    if (!useSequence) {
        const textCodeItem = generateBarcode(
            barcode,
            content,
            project,
            editorLayer
        );
        return content ? textCodeItem : false;
    }

    const { sequenceCount } = options;
    const previewSequence = generatePreviewSequence(
        start,
        count,
        step,
        leadingZeros,
        prefix,
        suffix
    );
    const displayText =
        typeof sequenceCount !== 'undefined'
            ? previewSequence[sequenceCount]
            : previewSequence[previewSequence.length - 1];
            console.log('displayTextbarcode',displayText);
    const sequenceCodeItem = generateBarcode(
        barcode,
        displayText,
        project,
        editorLayer
    );

    return sequenceCodeItem;
};


export const createCircleTextLayer = (
    curve,
    text,
    font,
    fontSize,
    fontSpacing,
    orientation
) => {
    const { origin, radius, rotationAngle } = curve;
    console.log('radius=================', radius);
    const refPath = new PaperJS.Path.Circle({
        center: origin,
        radius: radius,
        strokeColor: 'rgba(0,0,0,0.15)',
    });
    console.log('refPath',refPath)
    refPath.rotate(-90);
    refPath.rotate(rotationAngle);
    refPath.style = {
        fillColor: 'blue',
        strokeColor: 'red',
        strokeWidth: 5,
    };
       const adjustedFontSize = fontSize * window.devicePixelRatio;
    const adjustedFontSpacing = fontSpacing * window.devicePixelRatio;
    const newItem = createAlignedText(
        text,
        refPath,
        font,
        fontSize,
        fontSpacing,
        orientation
    );

    return text ? newItem : false;
};
export const createAlignedText = (
    string,
    refPath,
    font,
    fontSize,
    fontSpacing,
    orientation
) => {
    const text =
        orientation === 'down'
            ? string
                  .split('')
                  .reverse()
                  .join('')
            : string;
    const newLayer = new PaperJS.Layer();
    // const glyphs = font.stringToGlyphs(text);
    const glyphs = getGlyphsFromString(font, text);
    const fontScale = (1 / font.unitsPerEm) * fontSize;
    const ascender = font.ascender * fontScale;
    const descender = font.descender * fontScale;
    let charsList = [];
    let glyphsWidth = 0;
    let found = false;
    const refPathCenter = refPath.length / 2;

    // Ensure we always have fontSpacing value
    if (isNaN(fontSpacing) || fontSpacing == '') {
        fontSpacing = 0;
    }

    // get only the visible glyphs that fits the site of the refPath (circle)
    const reducedGlyphsList = glyphs.reduce((newList, glyph) => {
        const { advanceWidth } = glyph;
        const width = advanceWidth * fontScale + fontSpacing;
        if (refPath.length >= glyphsWidth + width && !found) {
            glyphsWidth = glyphsWidth + width;
            newList.push(glyph);
        } else {
            found = true;
        }
        return newList;
    }, []);

    let centerOffs = refPathCenter - glyphsWidth / 2;

    // cycle all glyphs
    reducedGlyphsList.map((glyph, i) => {
        const { yMin } = glyph;
        const name = text.substring(i, i + 1);
        const width = font.getAdvanceWidth(name, fontSize) + fontSpacing;
        const descent = yMin * fontScale;

        const glypPath = font.getPath(name, 0, 0, fontSize);
        const item = new PaperJS.CompoundPath(glypPath.toPathData());
        const rect = new PaperJS.Path.Rectangle({
            size: [width, ascender - descender],
        });
        const group = new PaperJS.Layer([item, rect]);
        item.position = [
            rect.bounds.center.x,
            rect.bounds.bottomRight.y -
                item.bounds.height / 2 +
                descender -
                descent,
        ];
        group.position.x = centerOffs - width / 2;

        if (!item.isEmpty()) charsList.push(item);

        centerOffs += width;

        if (refPath.length < centerOffs) {
            if (refPath.closed) {
                centerOffs = centerOffs % refPath.length;
            } else {
                centerOffs = undefined;
            }
        }

        if (centerOffs === undefined) {
            group.remove();
            charsList.pop();
        } else {
            const pathPoint = refPath.getPointAt(centerOffs - width / 2);
            group.position = pathPoint;
            const tan = refPath.getTangentAt(centerOffs - width / 2);

            if (orientation === 'down') {
                group.scale(-1, -1);
            }

            group.rotate(tan.angle);
        }

        // remove selection
        rect.remove();
    });

    newLayer.addChildren(charsList);

    // save pivot point
    const refPathPoint = refPath.getPointAt(refPathCenter);
    newLayer.data.pivot = refPathPoint.subtract(newLayer.bounds.center);

    // remove reftPath
    refPath.remove();

    return newLayer;
};

export const createTextLayer = (
    text,
    font,
    fontSize,
    fontSpacing,
    layerMaxWidth = null
) => {
    const newGroup = new PaperJS.Group();

    // Text
    // ---------
    let newLayer = new PaperJS.Layer();
    newLayer.name = 'text';
    newLayer.data.type = 'text';

    let textLayer = new PaperJS.CompoundPath();
    const glyphs = getGlyphsFromString(font, text);
    const fontScale = (1 / font.unitsPerEm) * fontSize;
    const ascender = font.ascender * fontScale;
    const descender = font.descender * fontScale;
    let charsList = [];
    let centerOffs = 0;
    let firstCharacterX = null;

    // Ensure we always have fontSpacing value
    if (isNaN(fontSpacing) || fontSpacing == '') {
        fontSpacing = 0;
    }

    // cycle all glyphs
    glyphs.map((glyph, i) => {
        const { yMin } = glyph;
        const name = text.substring(i, i + 1);
        const width = font.getAdvanceWidth(name, fontSize) + fontSpacing;
        const descent = yMin * fontScale;
        const glypPath = font.getPath(name, 0, 0, fontSize);
        const item = new PaperJS.CompoundPath(glypPath.toPathData());
        item.position = [
            centerOffs + width / 2,
            ascender - descender - item.bounds.height / 2 + descender - descent,
        ];

        // keep array of items and offsets
        if (!item.isEmpty()) charsList.push(item);

        centerOffs += width;

        if (firstCharacterX === null) {
            firstCharacterX = width / 2;
        }
    });

    textLayer.addChildren(charsList);

    // Create dummy text to ensure the height will not be jumpy
    let dummyTextList = [];
    let textMaxHeight = null;
    const dummyString = '0';
    const dummyGlyphs = font.stringToGlyphs(dummyString);
    dummyGlyphs.map((glyph, i) => {
        const { yMin } = glyph;
        const name = dummyString.substring(i, i + 1);
        const width = font.getAdvanceWidth(name, fontSize) + fontSpacing;
        const descent = yMin * fontScale;
        const glypPath = font.getPath(name, 0, 0, fontSize);
        const item = new PaperJS.CompoundPath(glypPath.toPathData());
        item.fillColor = 'rgba(0,0,0,0)';
        item.name = 'invisibletext';
        item.data.type = 'invisibletext';
        item.bounds.width = 0; // Force reduce the width
        item.position = [
            firstCharacterX,
            ascender - descender - item.bounds.height / 2 + descender - descent,
        ];

        // keep array of items and offsets
        if (!item.isEmpty()) dummyTextList.push(item);

        textMaxHeight = item.bounds.height;
    });

    // textLayer.addChildren(dummyTextList);
    newLayer.addChild(textLayer);

    if (textMaxHeight != null && newLayer.bounds.height > textMaxHeight) {
        const textScaling = textMaxHeight / newLayer.bounds.height;
        newLayer.scale(textScaling, textScaling);
    }

    // Extra bounding
    // ---------
    const rect = new PaperJS.Shape.Rectangle(newLayer.bounds);

    rect.fillColor = 'rgba(0,0,0,0.0)'; // shadowbound colour for debugging
    rect.name = 'shadowbound';
    rect.data.type = 'shadowbound';
    rect.sendToBack();

    newGroup.addChildren([newLayer, rect]);

    return newGroup;
};

export const createSVGLayer = (project, image) => {
    const item = flattenSVG(
        project.importSVG(image, {
            expandShapes: true,
            insert: false,
        })
    );

    return item;
};
//composeLayer(editorLayer, canvasLayer, scope, editor.present);

export const composeLayer = (
    editorLayer,
    canvasLayer,
    scope,
    editor,
    tagType,
    options = {}
) => {
    const { regions, textColour, activeLayer } = editor;
    const { region, activeType } = editorLayer;
    const editorRegion = regions[region];
    console.log('scope.editorRegion==================', editorRegion);
    console.log('scope.project==================', scope.project);
    const areaBoundBox = getLayerAreaBoundBox(scope.project, editorRegion);
    const { target, newCanvasLayer } = options;

    let newItem = false;

    canvasLayer.applyMatrix = false; // NOTE: http://paperjs.org/reference/item/#applymatrix

    switch (activeType) {
        case 'initialvalues': {
            newItem = getTextLayer(scope.project, areaBoundBox, editorLayer, {
                ...options,
            });

            break;
        }
        case 'text': {
            newItem = getTextLayer(scope.project, areaBoundBox, editorLayer, {
                ...options,
            });
            break;
        }
        case 'sequence': {
            newItem = getSequenceLayer(
                scope.project,
                areaBoundBox,
                editorLayer,
                {
                    ...options,
                }
            );
            break;
        }
        case 'list': {
            newItem = getCustomListLayer(
                scope.project,
                areaBoundBox,
                editorLayer,
                {
                    ...options,
                }
            );
            break;
        }
        case 'image': {
            newItem = getImageLayer(scope.project, editorLayer);
            break;
        }
        case 'code': {
            newItem = getCodeLayer(scope.project, areaBoundBox, editorLayer, {
                ...options,
            });
            break;
        }
        case 'rfid': {
            newItem = getTextLayer(scope.project, areaBoundBox, editorLayer, {
                ...options,
            });
            break;
        }
        default: {
            newItem = getTextLayer(scope.project, areaBoundBox, editorLayer, {
                ...options,
            });
        }
    }

    // return empty layer
    if (!newItem) {
        canvasLayer.removeChildren();
        hideCanvasSelection(canvasLayer);
        return canvasLayer;
    }

    // reset layer transformations
    canvasLayer.removeChildren(); // remove old elements
    canvasLayer.rotation = 0;
    canvasLayer.textOrientation = 'up';
    canvasLayer.scaling = [1, 1];

    // add new item
    newItem.position = [0, 0];
    canvasLayer.addChild(newItem);

    // pass the pivot point from item to layer
    if (newItem.data.pivot) {
        canvasLayer.data.pivot = newItem.data.pivot;
    } else {
        canvasLayer.data.pivot = null;
    }

    //setOriginalSize(canvasLayer); // keep the layer's original size
    paintLayer(canvasLayer, textColour); // paint the content based on colour selected
    scaleLayer(canvasLayer, editorLayer); // scale the layer based on user input
    scaleBasedOnShadowboundLayer(canvasLayer, editorLayer);
    rotateLayer(canvasLayer, editorLayer); // rotate the layer based on user input
    textOrientationLayer(canvasLayer, editorLayer); // mirror the layer based on user input

    if (activeType != 'rfid') {
        resizeLayer(canvasLayer, editorLayer, areaBoundBox);
        // if (newItem.data.pivot || activeType === 'image' || activeType === 'code' || target === 'fontSize' || target === 'rotation' || newCanvasLayer) {
        //     resizeLayer(canvasLayer, editorLayer, areaBoundBox);
        // } else {
        //     resizeLayerMaxWidth(canvasLayer, editorLayer, areaBoundBox, tagType, scope.project); // resize the element to fit the layer area
        // }
    }

    positionLayer(canvasLayer, editorLayer, areaBoundBox); // position the layer based on user input or area center
    repositionLayer(canvasLayer, areaBoundBox); // "push" the content inside the layer area
    addLayerSelection(canvasLayer); // add the selection rectangle to the layer
    //checkLayerOverlapping(canvasLayer, editorLayer);
    updateCanvasSelection(canvasLayer); // update canvas selection

    return canvasLayer;
};
export const setOriginalSize = (layer) => {
    if (layer.data.originalSize) return;
    layer.data.originalSize = {
        width: layer.bounds.width,
        height: layer.bounds.height,
    };
};

// error handling
export const addCanvasLayerError = (layer, message) => {
    if (layer.data.errors) {
        layer.data.errors.push({
            message: message,
        });
    } else {
        layer.data.errors = [
            {
                message: message,
            },
        ];
    }
};

// actions
export const changeCanvasFillColour = (params) => {
    return (dispatch, getState) => {
        const { editor } = getState();
        const { canvas: scopes, textColour } = editor.present;
        const canvasLayers = Object.values(scopes).reduce((aux, scope) => {
            const items = scope.project.getItems({
                class: 'Layer',
                match: (item) => item.data.type === 'layer',
            });
            return aux.concat(items);
        }, []);

        canvasLayers.map((item) => {
            paintLayer(item, textColour);
        });
    };
};

export const flipLayer = (params) => {
    // Flip the layer in X degrees
    return (dispatch, getState) => {
        const { layer, degrees } = params;
        const { editor, tagWizard } = getState();
        const { cartQty } = tagWizard.present.userInput;
        const { layers } = editor.present;
        const editorLayer = getLayerExtendedData(layers[layer], cartQty);
        const { previewText, rotation } = editorLayer;

        let newRotation;
        if (rotation === undefined) {
            newRotation = degrees;
        } else {
            newRotation = rotation + degrees;
        }

        if (newRotation < 0) {
            newRotation = 270;
        } else if (newRotation === 360) {
            newRotation = 0;
        }
        if (!previewText) return;

        dispatch(changeLayerRotation(layer, newRotation));
    };
};

export const textOrientationLayer = (params) => {
    // updates text to upside down and from left to right and vice versa

    return (dispatch, getState) => {
        const { layer } = params;
        const { editor, tagWizard } = getState();
        const { cartQty } = tagWizard.present.userInput;
        const { layers } = editor.present;
        const editorLayer = getLayerExtendedData(layers[layer], cartQty);
        const { previewText, textOrientation } = editorLayer;

        const newTextOrientation = textOrientation === 'down' ? 'up' : 'down';

        if (!previewText) return;
        dispatch(changeLayerTextOrientation(layer, newTextOrientation));
    };
};

export const snapLayer = (params) => {
    return (dispatch, getState) => {
        const { layer, align } = params;
        const { editor, tagWizard } = getState();
        const { cartQty } = tagWizard.present.userInput;
        const { regions, layers, canvas } = editor.present;
        const editorLayer = getLayerExtendedData(layers[layer], cartQty);
        const { previewText } = editorLayer;
        const scope = canvas[editorLayer.side];
        const canvasLayer = getCanvasItem(layer, scope.project);
        const editorRegion = regions[canvasLayer.data.region];
        const areaBoundBox = getLayerAreaBoundBox(scope.project, editorRegion);

        if (!previewText) return;

        if (align === 'left') {
            canvasLayer.position.x = areaBoundBox.leftCenter.x;
        } else if (align === 'right') {
            canvasLayer.position.x = areaBoundBox.rightCenter.x;
        } else {
            canvasLayer.position.x = areaBoundBox.center.x;
        }

        const { bounds } = canvasLayer;
        const percentageBounds = {
            x: Number(
                (
                    ((bounds.center.x - areaBoundBox.x) * 100) /
                    areaBoundBox.width
                ).toFixed(2)
            ),
            y: Number(
                (
                    ((bounds.center.y - areaBoundBox.y) * 100) /
                    areaBoundBox.height
                ).toFixed(2)
            ),
            width: (bounds.width * 100) / areaBoundBox.width,
            height: (bounds.height * 100) / areaBoundBox.height,
        };

        repositionLayer(canvasLayer, areaBoundBox);

        dispatch(
            changeLayerPosition(layer, {
                x: percentageBounds.x,
                y: percentageBounds.y,
            })
        );
    };
};
export const changeCanvasLayerField = (params) => {
    return (dispatch, getState) => {
        const { editor, tagWizard } = getState();
        const { cartQty, tagType } = tagWizard.present.userInput;
        const { layers, canvas } = editor.present;
        const { layer, target } = params;
        const editorLayer = getLayerExtendedData(layers[layer], cartQty);
        const scope = canvas[editorLayer.side];
        const canvasLayer = getCanvasItem(layer, scope.project);

        composeLayer(editorLayer, canvasLayer, scope, editor.present, tagType, {
            target,
        });
    };
};
export const changeCanvasRegionStyle = (params) => {
    return (dispatch, getState) => {
        const { region, style } = params;
        const { editor } = getState();
        const { regions, canvas: scopes } = editor.present;
        const editorRegion = regions[region];
        const scope = scopes[editorRegion.side];

        scope.project
            .getItems({
                class: 'Layer',
                match: (item) =>
                    item.data.region === region && item.data.type === 'layer',
            })
            .map((item) => (item.visible = false));

        scope.project
            .getItems({
                class: 'Layer',
                match: (item) =>
                    item.data.style === style && item.data.type === 'layer',
            })
            .map((item) => (item.visible = true));
    };
};
export const toggleCanvasRegions = (region) => {
    return (dispatch, getState) => {
        const { editor } = getState();
        const { canvas, regions } = editor.present;
        const editorRegion = regions[region];
        const scope = canvas[editorRegion.side];
        const canvasRegion = getCanvasItem(region, scope.project);
        canvasRegion.visible = editorRegion.active;
    };
};
export const saveCanvasLayer = (layer) => {
    return (dispatch, getState) => {
        const { editor } = getState();
        const { layers, canvas: scopes } = editor.present;
        const editorLayer = layers[layer];
        const scope = scopes[editorLayer.side];
        const canvasLayer = getCanvasItem(layer, scope.project);
        const others = Object.values(scopes).reduce((aux, scope) => {
            const items = scope.project.getItems({
                class: 'Layer',
                match: (item) => item.data.type === 'layer',
            });
            return aux.concat(items);
        }, []);

        enableLayers(others);
        hideCanvasSelection(canvasLayer);
    };
};
export const selectCanvasLayer = (layer) => {
    return (dispatch, getState) => {
        const { editor, tagWizard } = getState();
        const { layers, canvas: scopes } = editor.present;
        const { cartQty, tagType } = tagWizard.present.userInput;
        const scope = scopes[layers[layer].side];
        const canvasLayer = getCanvasItem(layer, scope.project);
        const others = Object.values(scopes).reduce((aux, scope) => {
            const items = scope.project.getItems({
                class: 'Layer',
                match: (item) =>
                    item.name !== layer && item.data.type === 'layer',
            });
            return aux.concat(items);
        }, []);

        disableLayers(others);
        // enableLayer(canvasLayer);
        selectLayer(canvasLayer, 'SideMenuScreen');
        const editorLayer = getLayerExtendedData(layers[layer], cartQty);
        composeLayer(editorLayer, canvasLayer, scope, editor.present, tagType);
    };
};
export const cancelCanvasLayer = (layer) => {
    return (dispatch, getState) => {
        if (!layer) return;
        const { editor, tagWizard } = getState();
        const { cartQty, tagType } = tagWizard.present.userInput;
        const { layers, canvas: scopes } = editor.present;
        const editorLayer = getLayerExtendedData(layers[layer], cartQty);
        const canvasLayer = Object.values(scopes).reduce((aux, scope) => {
            if (aux) return aux;
            return (
                scope.project.getItem({
                    match: (item) => item.name === layer,
                }) || false
            );
        }, false);
        const others = Object.values(scopes).reduce((aux, scope) => {
            const items = scope.project.getItems({
                class: 'Layer',
                match: (item) =>
                    item.name !== layer && item.data.type === 'layer',
            });
            return aux.concat(items);
        }, []);
        const scope = scopes[canvasLayer.data.side];

        if (canvasLayer && editorLayer) {
            composeLayer(
                editorLayer,
                canvasLayer,
                scope,
                editor.present,
                tagType
            );
        } else {
            canvasLayer.remove();
        }
        enableLayer(canvasLayer);
        enableLayers(others);
        hideCanvasSelection(canvasLayer);
    };
};
export const createNewLayer = (editorLayer, scope) => {
    const { id, style, region, side, activeType } = editorLayer;
    console.log('editorLayer=====================', editorLayer);
    const canvasSide = getCanvasItem(side, scope.project);

    const canvasLayer = new PaperJS.Layer();
    console.log('canvasLayer==================', canvasLayer);
    canvasLayer.name = id;
    canvasLayer.data.id = id;
    canvasLayer.data.type = 'layer';
    canvasLayer.data.style = style;
    canvasLayer.data.region = region;
    canvasLayer.data.side = side;
    canvasLayer.addTo(canvasSide);

    createActiveLayerBinds(canvasLayer);

    return canvasLayer;
};
export const addCanvasLayer = (layer) => {
    return (dispatch, getState) => {
        const { editor, tagWizard } = getState();
        const { cartQty, tagType } = tagWizard.present.userInput;
        const { activeLayer, layers, canvas: scopes } = editor.present;
        //const id = layer.id;
        // const editorLayer = getLayerExtendedData(activeLayer);
        const editorLayer = getLayerExtendedData(layer, cartQty);
        // const editorLayer = layers[layer];
        const scope = scopes[Object.values(editorLayer)[0].side];
        const others = Object.values(scopes).reduce((aux, scope) => {
            const items = scope.project.getItems({
                class: 'Layer',
                match: (item) =>
                    item.name !== activeLayer && item.data.type === 'layer',
            });
            return aux.concat(items);
        }, []);

        const canvasLayer = createNewLayer(
            Object.values(editorLayer)[0],
            scope
        );
        // composeLayer(editorLayer, canvasLayer, scope, editor.present);
        composeLayer(
            Object.values(editorLayer)[0],
            canvasLayer,
            scope,
            editor.present,
            tagType,
            {
                newCanvasLayer: true,
            }
        );
        disableLayers(others);
        enableLayer(canvasLayer);
        selectLayer(canvasLayer, 'SideMenuScreen');
        //selectLayer(canvasLayer);
    };
};
export const removeCanvasLayer = (layer) => {
    return async (dispatch, getState) => {
        const { editor } = getState();
        const { layers, canvas: scopes } = editor.present;
        const editorLayer = layers[layer];
        const scope = scopes[editorLayer.side];
        const canvasLayer = getCanvasItem(layer, scope.project);
        const others = Object.values(scopes).reduce((aux, scope) => {
            const items = scope.project.getItems({
                class: 'Layer',
                match: (item) =>
                    item.data.id !== layer && item.data.type === 'layer',
            });
            return aux.concat(items);
        }, []);

        // Hide it first
        canvasLayer.visible = false;

        // Do stuff that needs to be done
        await enableLayers(others);
        await hideCanvasSelection(canvasLayer);

        // And then remove
        canvasLayer.remove();
    };
};

// interactions (canvas)
export const canvasMouseLeave = (e) => {
    e.target.element.style.cursor = 'default';
};


export const canvasResize = (e, scope) => {
    const { size, delta } = e;
    const prevWidth = size.width - delta.width;
    const scaleFactor = 1 / (prevWidth / size.width);

    console.log(
        '> Running canvasResize()',
        'scaleFactor:',
        scaleFactor,
        'prevWidth:',
        prevWidth,
        'size.width:',
        size.width,
        'delta.width:',
        delta.width
    );

    // Scale the view of the canvas whenever it is resized
    scope.view.scale(scaleFactor, [0, 0]);
};

// interactions (layers)
export const createActiveLayerBinds = (canvasLayer) => {
    canvasLayer.onMouseLeave = (e) => layerMouseLeave(e);
    canvasLayer.onMouseMove = (e) => layerMouseMove(e);
    canvasLayer.onMouseDown = (e) => layerMouseDown(e);
};

export const layerMouseLeave = (e) => {
    e.event.target.style.cursor = 'default';
};

export const layerMouseMove = (e) => {
    e.event.target.style.cursor = 'pointer';
};

export const layerMouseDown = (e) => {
    const { activeLayer } = store.getState().editor.present;
    const canvasLayer = e.target;

    if (activeLayer !== e.target.data.id) {
        store.dispatch(selectEditorLayer(canvasLayer.data.id));
    }
};
export const selectLayer = (layer, gotoScreen) => {
    layer.bringToFront();
    updateCanvasSelection(layer);

    if (gotoScreen) {
        store.dispatch(changeScreen(gotoScreen));
    }
    // trigger focus on content field
    focusContentField();
};
export const enableLayer = (layer) => {
    // layer.opacity = 1;
    if (layer.children[0]) {
        layer.children[0].opacity = 1;
        layer.locked = false;
    }
};
export const enableLayers = (layers) => {
    layers &&
        layers.map((layer) => {
            enableLayer(layer);
        });
};
export const disableLayer = (layer) => {
    if (layer.children[0]) {
        layer.children[0].opacity = 0.2;
        layer.locked = true;
    }
};
export const disableLayers = (layers) => {
    layers.map((layer) => {
        disableLayer(layer);
    });
};
export const addProjectSelection = (project) => {
    const boundLayer = new PaperJS.Layer();
    const topLeftRect = new PaperJS.Path.Rectangle({
        x: project.view.bounds.topLeft.x,
        y: project.view.bounds.topLeft.y,
        width: 0.1,
        height: 0.1,
    });
    const bottomRightRect = new PaperJS.Path.Rectangle({
        x: project.view.bounds.bottomRight.x,
        y: project.view.bounds.bottomRight.y,
        width: 0.1,
        height: 0.1,
    });

    project.addLayer(boundLayer);

    topLeftRect.addTo(boundLayer);
    topLeftRect.name = 'topLeft';
    topLeftRect.sendToBack();

    bottomRightRect.addTo(boundLayer);
    bottomRightRect.name = 'bottomRight';
    bottomRightRect.sendToBack();
};
export const addLayerSelection = (layer) => {
    // const { scaling, bounds, rotation } = layer;
    const { bounds } = layer.children[0]; // NOTE: the layer has transformation saved in the matrix, so the bounds values are not reflecting it's final visual values. Instead of getting them from the layer itself, we get from the content (first child)
    const rect = new PaperJS.Path.Rectangle(layer.bounds);

    rect.bounds.width = bounds.width;
    rect.bounds.height = bounds.height;

    rect.position = [0, 0]; // NOTE: when applyMatrix = false

    rect.fillColor = 'rgba(0,0,0, 0.001)';
    rect.name = 'selection';
    rect.data.type = 'selection';
    rect.addTo(layer);
    rect.bringToFront();
};

export const centerLayer = (layer, box) => {
    layer.position = box.center;
};

export const resizeLayerMaxWidth = (
    canvasLayer,
    editorLayer,
    box,
    tagType,
    project
) => {
    const { layerMaxWidth } = editorLayer;
    const { id } = canvasLayer.data;

    if (tagType === 'nlis' && layerMaxWidth) {
        if (canvasLayer.bounds.width >= layerMaxWidth) {
            canvasLayer.scale(box.width / canvasLayer.bounds.width, 1);
            canvasLayer.bounds.width = layerMaxWidth;
        }
    } else {
        const selectionLayer = getCanvasItem('selection', project);

        if (!selectionLayer) {
            return;
        }

        const rect =
            selectionLayer.getItem({
                recursive: false,
                match: (item) => item.name === 'rect',
            }) || false;

        canvasLayer.scale(box.width / canvasLayer.bounds.width, 1);
        canvasLayer.bounds.width = rect.bounds.width;
        canvasLayer.bounds.height = rect.bounds.height;
    }

    if (canvasLayer.bounds.height >= box.height) {
        canvasLayer.scale(box.height / canvasLayer.bounds.height);
        canvasLayer.bounds.height = rect.bounds.height;
    }

    const scale = {
        x: Number(canvasLayer.matrix.scaling.x.toFixed(2)),
        y: Number(canvasLayer.matrix.scaling.y.toFixed(2)),
    };

    store.dispatch(changeLayerScale(id, scale));
};



export const resizeLayer = (canvasLayer, editorLayer, box) => {
    if (canvasLayer.bounds.width >= box.width) {
        canvasLayer.scale(box.width / canvasLayer.bounds.width);
    }

    if (canvasLayer.bounds.height >= box.height) {
        canvasLayer.scale(box.height / canvasLayer.bounds.height);
    }
};

export const scaleBasedOnShadowboundLayer = (canvasLayer, editorLayer) => {
    const autoScaleTypeLayer = isAutoScaleTypeLayer(editorLayer);
    const { layerMaxWidth } = editorLayer;
    const shadowBoundItem = getShadowboundCanvasItem(canvasLayer);
    const textItem = getTextCanvasItem(canvasLayer);

    const precisionHelper = (number) => Math.round(number * 10000);

    if (autoScaleTypeLayer && shadowBoundItem && textItem) {
        const textWidth = textItem.bounds.width;
        const newMaxWidth =
            layerMaxWidth != null && layerMaxWidth > 0
                ? layerMaxWidth
                : textWidth;
        const finalShadowBoundWidth = Math.max(newMaxWidth, textWidth);
        const finalShadowBoundHeight = textItem.bounds.height;

        shadowBoundItem.setSize([
            finalShadowBoundWidth,
            finalShadowBoundHeight,
        ]);

        // Recalculate canvas scaling
        const canvasLayerWidth = canvasLayer.bounds.width;

        if (precisionHelper(canvasLayerWidth) > precisionHelper(newMaxWidth)) {
            const scaleX = newMaxWidth / canvasLayerWidth;

            canvasLayer.scale(scaleX, 1);
        }
    }
};

export const rotateLayer = (canvasLayer, editorLayer) => {
    // const curve = getCurve(editorLayer);
    const { rotation = 0 } = editorLayer;
    // if (curve) return;
    canvasLayer.rotate(rotation);
};

// export const flipTextOrientationLayer = (canvasLayer, editorLayer) => {
//   // const curve = getCurve(editorLayer);
//   const { textOrientation = 'up' } = editorLayer;
//   // if (curve) return;
//  // canvasLayer.mirror(mirror);
// };

export const scaleLayer = (canvasLayer, editorLayer) => {
    const { scale } = editorLayer;
    const noFreeTransform =
        isSquareBarcode(editorLayer) ||
        isImage(editorLayer) ||
        isRFID(editorLayer);
    const autoScaleTypeLayer = isAutoScaleTypeLayer(editorLayer);
    if (!scale) return;

    let scaleX = scale.x < minScaleX ? minScaleX : scale.x;
    const scaleY = scale.y < minScaleY ? minScaleY : scale.y;

    // The scaling for autoScaleTypeLayer will be done on the other function.
    if (autoScaleTypeLayer) {
        scaleX = 1;
    }

    if (noFreeTransform) {
        canvasLayer.scale(scaleX, scaleX);
    } else {
        canvasLayer.scale(scaleX, scaleY);
    }
};
export const positionLayer = (canvasLayer, editorLayer, box) => {
    const { position } = editorLayer;
    const { pivot } = canvasLayer.data;
    let newPosition = getPointByPercentage(box, position);
    if (pivot) {
        newPosition = newPosition.subtract(pivot);
    }
    if (position) {
        canvasLayer.position = newPosition;
    }
};
export const repositionLayer = (layer, box) => {
    if (layer.bounds.leftCenter.x < box.x) {
        layer.position.x = layer.bounds.width / 2 + box.x;
    }
    if (layer.bounds.rightCenter.x > box.x + box.width) {
        layer.position.x = box.width + box.x - layer.bounds.width / 2;
    }
    if (layer.bounds.topCenter.y < box.y) {
        layer.position.y = layer.bounds.height / 2 + box.y;
    }
    if (layer.bounds.bottomCenter.y > box.y + box.height) {
        layer.position.y = box.height + box.y - layer.bounds.height / 2;
    }
};
export const paintLayer = (canvasLayer, colour) => {
    canvasLayer.getItems({
        recursive: false,
        match: (item) => {
            if (item instanceof PaperJS.Group) {
                paintLayer(item, colour);
            } else {
                if (item.name !== 'selection' && item.name !== 'shadowbound') {
                    item.fillColor = colour;
                }

                if (
                    typeof item.data.type != 'undefined' &&
                    item.data.type == 'invisibletext'
                ) {
                    item.fillColor = 'rgba(0,0,0,0.0)';
                }
            }
        },
    });
};
export const dragScaleLayer = (item, selectionLayer, editorLayer, e) => {
    const { x, y } = e.delta;
    const { altKey } = e.event;
    const { segmentPoint } = e.target.data;
    const {
        center,
        topLeft,
        topRight,
        topCenter,
        bottomLeft,
        bottomRight,
        bottomCenter,
        leftCenter,
        rightCenter,
        width,
        height,
    } = item.bounds;
    // const rectWidth = width - handleSize;
    // const rectHeight = height - handleSize;

    // const rectWidth = width || 10;
    // const rectHeight = height || 10;
    const rectWidth = width;
    const rectHeight = height;
    let delta = 0;
    let scaleX = 1;
    let scaleY = 1;
    let refPoint = center;
    let scaleFactor = 1;
    const resizePoints = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];

    const autoScaleTypeLayer = isAutoScaleTypeLayer(editorLayer);

    // corners
    if (resizePoints.includes(segmentPoint)) {
        delta = altKey ? x * 2 : x;

        if (segmentPoint === 'topLeft') {
            refPoint = bottomRight;
        } else if (segmentPoint === 'topRight') {
            refPoint = bottomLeft;
        } else if (segmentPoint === 'bottomLeft') {
            refPoint = topRight;
        } else if (segmentPoint === 'bottomRight') {
            refPoint = topLeft;
        }
        if (segmentPoint.includes('Left')) {
            scaleFactor = -1;
        }

        scaleX = (delta * scaleFactor + rectWidth) / rectWidth;
        scaleY = scaleX;
    }
    // centers
    else {
        if (segmentPoint === 'topCenter') {
            delta = altKey ? y * 2 : y;
            scaleY = (delta * -1 + rectHeight) / rectHeight;
            refPoint = bottomCenter;
        } else if (segmentPoint === 'bottomCenter') {
            delta = altKey ? y * 2 : y;
            scaleY = (delta + rectHeight) / rectHeight;
            refPoint = topCenter;
        } else if (segmentPoint === 'leftCenter') {
            delta = altKey ? x * 2 : x;
            scaleX = (delta * -1 + rectWidth) / rectWidth;
            refPoint = rightCenter;
        } else if (segmentPoint === 'rightCenter') {
            delta = altKey ? x * 2 : x;
            scaleX = (delta + rectWidth) / rectWidth;
            refPoint = leftCenter;
        }
    }

    if (altKey) {
        refPoint = center;
    }

    // scaling check to not reverse
    if (scaleX > 0 && scaleY > 0) {
        // AutoScaling type layer: text based like text, sequence, list, etc
        const shadowBoundItem = getShadowboundCanvasItem(item);
        const textItem = getTextCanvasItem(item);

        if (autoScaleTypeLayer && shadowBoundItem && textItem) {
            const editorLayerRotation = editorLayer.rotation || 0;
            const layerRotation = Math.abs(Math.round(editorLayerRotation));
            const isVertical = layerRotation === 90 || layerRotation === 270;

            const textItemWidth = textItem.bounds.width;
            const newShadowBoundWidth = isVertical
                ? shadowBoundItem.size.width * scaleY
                : shadowBoundItem.size.width * scaleX;
            const originalItemScalingX = 1 / item.scaling.x;

            // console.log('DEBUG - isVertical', isVertical, layerRotation);
            // console.log('DEBUG - scale', scaleX, scaleY);

            // console.log('-- ORIGINAL ------');
            // console.log('> item:', 'width:', item.bounds.width, 'height:', item.bounds.height, 'scale:', item.scaling.x, item.scaling.y);
            // console.log('> shadowBoundItem:', 'width:', shadowBoundItem.bounds.width, 'scale:', shadowBoundItem.scaling.x, shadowBoundItem.scaling.y);
            // console.log('> textItem:', 'width:', textItem.bounds.width, 'scale:', textItem.scaling.x, textItem.scaling.y);
            // console.log('-- MODIFYING ------');

            if (
                newShadowBoundWidth > textItemWidth &&
                originalItemScalingX <= 1
            ) {
                if (isVertical) {
                    // This is the best possible way I can make it to work
                    // Tried to directly modify the layer scaling, but the calculatio is always off.
                    // Therefore: reverse the rotate, scale it, and then put back the rotate
                    item.rotate(-editorLayerRotation);
                    shadowBoundItem.setSize([
                        newShadowBoundWidth,
                        textItem.bounds.height,
                    ]);
                    item.scale(originalItemScalingX, scaleX, refPoint);
                    item.rotate(editorLayerRotation);

                    // console.log('(A1) selectionDrag - canvasLayer', item);
                    // console.log('> scaling to:', scaleX, originalItemScalingY);
                    // console.log('> item:', 'width:', item.bounds.width, 'height:', item.bounds.height, 'scale:', item.scaling.x, item.scaling.y);
                    // console.log('> shadowBoundItem:', 'width:', shadowBoundItem.bounds.width, 'scale:', shadowBoundItem.scaling.x, shadowBoundItem.scaling.y);
                    // console.log('> textItem:', 'width:', textItem.bounds.width, 'scale:', textItem.scaling.x, textItem.scaling.y);
                } else {
                    shadowBoundItem.setSize([
                        newShadowBoundWidth,
                        textItem.bounds.height,
                    ]);
                    item.scale(originalItemScalingX, scaleY, refPoint);

                    // console.log('(A2) selectionDrag - canvasLayer', item);
                    // console.log('> scaling to:', originalItemScalingX, scaleY);
                    // console.log('> item:', 'width:', item.bounds.width, 'height:', item.bounds.height, 'scale:', item.scaling.x, item.scaling.y);
                    // console.log('> shadowBoundItem:', 'width:', shadowBoundItem.bounds.width, 'scale:', shadowBoundItem.scaling.x, shadowBoundItem.scaling.y);
                    // console.log('> textItem:', 'width:', textItem.bounds.width, 'scale:', textItem.scaling.x, textItem.scaling.y);
                }
            } else {
                shadowBoundItem.setSize([
                    textItem.bounds.width,
                    textItem.bounds.height,
                ]);
                item.scale(scaleX, scaleY, refPoint);

                // console.log('(B) selectionDrag - canvasLayer', item);
                // console.log('> scaling to:', scaleX, scaleY);
                // console.log('> item:', 'width:', item.bounds.width, 'height:', item.bounds.height, 'scale:', item.scaling.x, item.scaling.y);
                // console.log('> shadowBoundItem:', 'width:', shadowBoundItem.bounds.width, 'scale:', shadowBoundItem.scaling.x, shadowBoundItem.scaling.y);
                // console.log('> textItem:', 'width:', textItem.bounds.width, 'scale:', textItem.scaling.x, textItem.scaling.y);
            }
        } else {
            item.scale(scaleX, scaleY, refPoint);
        }
    }
};
export const dragMoveLayer = (item, e) => {
    item.translate(e.delta);
};
export const createBoundBox = (viewBounds, layerBounds) => {
    if (!viewBounds || !layerBounds) return false;
    const rect = new PaperJS.Rectangle({
        x:
            layerBounds.x != undefined && viewBounds.x != undefined
                ? (layerBounds.x / 100) * viewBounds.width + viewBounds.x
                : false,
        y:
            layerBounds.y != undefined && viewBounds.y != undefined
                ? (layerBounds.y / 100) * viewBounds.height + viewBounds.y
                : false,
        height:
            layerBounds.height != undefined && viewBounds.height != undefined
                ? (layerBounds.height / 100) * viewBounds.height
                : false,
        width:
            layerBounds.width != undefined && viewBounds.width != undefined
                ? (layerBounds.width / 100) * viewBounds.width
                : false,
    });
    return rect;
};
export const getLayerNewPosition = (position, box) => {
    if (position.x < box.x) {
        position.x = box.x;
    }
    if (position.x > box.x + box.width) {
        position.x = box.x + box.width;
    }
    if (position.y < box.y) {
        position.y = box.y;
    }
    if (position.y > box.y + box.height) {
        position.y = box.y + box.height;
    }

    return position;
};
export const getPointByPercentage = (box, position) => {
    return new PaperJS.Point(
        (position.x / 100) * box.width + box.x,
        (position.y / 100) * box.height + box.y
    );
};
export const checkLayerOverlapping = (canvasLayer, editorLayer) => {
    let hasIntersection = false;
    const { id } = canvasLayer.data;
    const siblingLayers = canvasLayer.parent.getItems({
        recursive: false,
        match: (item) => {
            if (item.name !== 'mask' && item !== canvasLayer && item.visible) {
                // item.children['selection'].visible = false;
                return item;
            }
            return false;
        },
    });
    for (const siblingLayer of siblingLayers) {
        if (
            canvasLayer.intersects(siblingLayer) ||
            canvasLayer.isInside(siblingLayer.bounds)
        ) {
            hasIntersection = true;
        }
        // siblingLayer.children['selection'].visible = true;
    }

    if (hasIntersection) {
        store.dispatch(
            toggleLayerError({ layer: id, target: 'intersection', value: true })
        );
    } else {
        if (editorLayer.errors.intersection) {
            store.dispatch(
                toggleLayerError({
                    layer: id,
                    target: 'intersection',
                    value: false,
                })
            );
        }
    }
};

export const createCanvasSelection = (side, canvasSide) => {
    // creates the path and handles used to select and redimension the layers
    const selection = new PaperJS.Layer();
    const rect = new PaperJS.Path.Rectangle(
        new PaperJS.Point(-handleSize, -handleSize),
        1
    );

    console.log('canvasSide================', canvasSide);

    selection.name = 'selection';
    selection.data.id = 'selection';
    selection.data.type = 'selection';
    selection.addTo(canvasSide.project);
    selection.bringToFront();

    rect.strokeWidth = selectionWidth;
    rect.strokeColor = selectionColor;
    rect.fillColor = 'rgba(0,0,0, 0.001)';
    rect.dashArray = [4, 4]; // dashed
    rect.name = 'rect';
    rect.data.type = 'rect';
    rect.addTo(selection);

    [
        { point: selection.bounds.topCenter, name: 'topCenter' },
        { point: selection.bounds.topLeft, name: 'topLeft' },
        { point: selection.bounds.topRight, name: 'topRight' },
        { point: selection.bounds.bottomCenter, name: 'bottomCenter' },
        { point: selection.bounds.bottomLeft, name: 'bottomLeft' },
        { point: selection.bounds.bottomRight, name: 'bottomRight' },
        { point: selection.bounds.leftCenter, name: 'leftCenter' },
        { point: selection.bounds.rightCenter, name: 'rightCenter' },
    ].forEach(({ point, name }) => {
        // const handle = new PaperJS.Path.Rectangle(
        //     new PaperJS.Rectangle(point.subtract(handleSize / 2), handleSizeRegion)
        // );
        const handle = new PaperJS.Shape.Circle(
            point.subtract(handleSize / 2),
            handleSizeRegion
        );
        handle.fillColor = handleColor;
        handle.name = name;
        handle.data.type = 'handle-visual';
        handle.addTo(selection);

        const handleShadow = new PaperJS.Shape.Rectangle(
            new PaperJS.Rectangle(
                point.subtract(handleSize / 2),
                handleSize + 25
            )
        );
        handleShadow.fillColor = 'rgba(0,0,0,0.0001)';
        handleShadow.name = name;
        handleShadow.data.type = 'handle';
        handleShadow.addTo(selection);
    });

    createSelectionBinds(selection);
};
export const createCanvasClippingMask = (side, canvasSide) => {
    if (!side.clippingMask) return;
    const clippingMask = flattenSVG(
        canvasSide.importSVG(side.clippingMask, {
            expandShapes: true,
            insert: false,
        })
    );
    clippingMask.name = 'mask';
    clippingMask.data.type = 'mask';
    clippingMask.addTo(canvasSide);
    clippingMask.sendToBack();
    clippingMask.fitBounds(canvasSide.project.view.bounds);
    canvasSide.clipped = true;
};
export const startPaperJS = (canvas) => {
    const scope = new PaperJS.PaperScope();
    scope.setup(canvas);

    scope.view.onMouseLeave = (e) => canvasMouseLeave(e);
    scope.view.onResize = (e) => canvasResize(e, scope);
    // Ex: tag generated on mobile using fontSize 32 will look different when generated in browser window 1920x1200 (default)
    return scope;
};
export const createCanvasStructure = (side, scope, editor, tagType) => {
    console.log('side=========================', side);
    side.regions &&
        Object.values(side.regions).map((region) => {
            console.log('scope===================', scope);
            console.log('scope===================', scope.project);
            const { active: regionActive, activeStyle } = region;
            region.styles &&
                Object.values(region.styles).map((style) => {
                    style.layers &&
                        Object.values(style.layers).map((editorLayer) => {
                            console.log(
                                'styleLayers=====================',
                                style
                            );
                            if (
                                side.active &&
                                regionActive &&
                                activeStyle === style.id
                            ) {
                                const canvasLayer = createNewLayer(
                                    editorLayer,
                                    scope
                                );
                                const newLayer = composeLayer(
                                    editorLayer,
                                    canvasLayer,
                                    scope,
                                    editor,
                                    tagType
                                );
                            }

                            // const canvasLayer = createNewLayer(editorLayer, scope);
                            // const newLayer = composeLayer(editorLayer, canvasLayer, scope, editor, tagType);
                            //
                            // if (side.active && regionActive && activeStyle === style.id) {
                            //     newLayer.visible = true;
                            // } else {
                            //     newLayer.visible = false;
                            // }
                        });
                });
        });
};
export const adjustImageScalingOnUpload = (layer) => {
    return (dispatch, getState) => {
        const { editor, tagWizard, tag } = getState();
        const { cartQty } = tagWizard.present.userInput;
        const { layers, canvas } = editor.present;
        const { type = {} } = tag;
        const { initialImageWidth = null, initialImageHeight = null } = type;
        const editorLayer = getLayerExtendedData(layers[layer], cartQty);
        const scope = canvas[editorLayer.side];
        const canvasLayer = getCanvasItem(layer, scope.project);

        const layerOriginalWidth =
            canvasLayer.bounds.width / canvasLayer.scaling.x;
        const layerOriginalHeight =
            canvasLayer.bounds.height / canvasLayer.scaling.y;

        const defaultImageWidth = initialImageWidth || INITIAL_IMAGE_MAX_WIDTH;
        const defaultImageHeight =
            initialImageHeight || INITIAL_IMAGE_MAX_HEIGHT;

        const requireScaling =
            layerOriginalWidth > defaultImageWidth ||
            layerOriginalHeight > defaultImageHeight;

        if (requireScaling === true) {
            let scaling = 1;
            if (layerOriginalWidth > layerOriginalHeight) {
                // scale by width
                scaling = defaultImageWidth / layerOriginalWidth;
            } else {
                // scale by height
                scaling = defaultImageHeight / layerOriginalHeight;
            }

            dispatch(changeLayerScale(layer, { x: scaling, y: scaling }, true));
        } else {
            // Reset scaling to 1
            dispatch(changeLayerScale(layer, { x: 1, y: 1 }, true));
        }
    };
};
